module.exports = __webpack_public_path__ + "assets/adpoly-it-laptops-bulk-upload-template.da82d29e.xlsx";